import { IOption } from "Dashboard/domain/IOption";
import { hrsService } from "../services/hrs.services";
import { useEffect, useState } from "react";
import { salesUnitTypeDictionary } from "utils/translationDictionary";

export function useSUTypeOptions() {
    const [options, setOptions] = useState<IOption[]>([]);

    useEffect(() => {
        async function getSalesUnitTypes() {
            const data = await hrsService.getSalesUnitTypes();
            const op = data.map((type) => {
                return {
                    label: salesUnitTypeDictionary[type.name],
                    value: type.typeId,
                };
            });
            setOptions(op);
        }

        try {
            getSalesUnitTypes();
        } catch (err) {
            console.log(err);
        }
    }, []);

    return options;
}
